import React from 'react';
import { Link } from 'react-router-dom';
import { about } from '../data/about';
export function About() {
  return <main id="main" className="bg-paper" data-id="element-298" data-mp="2o9kzy4b42a6z">
      <section className="mx-auto grid max-w-shell items-center gap-16 px-6 py-20 lg:grid-cols-[0.85fr_1.15fr] lg:px-10 lg:py-28" data-id="element-299" data-mp="2oacmkpmqcxl4">
        <img src={about.portrait} alt={about.portraitAlt} className="photo-soft aspect-[4/5] w-full object-cover" data-id="element-300" data-mp="2ei6uzh0e4i6g" />
        <div data-id="element-301" data-mp="3292mse4ujddp">
          <p className="label text-olive" data-id="element-302" data-mp="326gegca4stuf">{about.greeting}</p>
          <h1 className="mt-7 max-w-xl font-display text-[44px] font-300 leading-[1.02] text-ink sm:text-[58px]" data-id="element-303" data-mp="3762sup1p4g4t">
            {about.headline}
          </h1>
          <div className="mt-9 max-w-prose space-y-6" data-id="element-304" data-mp="2x8y20bwwnwho">
            {about.story.map(para => <p key={para.slice(0, 24)} className="text-[16.5px] leading-[1.9] text-ink/80" data-id="element-305" data-mp="1gv7uswahos3t">
                {para}
              </p>)}
          </div>
        </div>
      </section>

      <section aria-labelledby="promise-h" className="border-t border-line bg-white" data-id="element-306" data-mp="1uhidfb8a0e42">
        <div className="mx-auto max-w-shell px-6 py-24 lg:px-10 lg:py-28" data-id="element-307" data-mp="1ujmocd4leddu">
          <p className="label text-olive" data-id="element-308" data-mp="1pkjiwrkpa55c">What you can count on</p>
          <h2 id="promise-h" className="mt-6 max-w-2xl font-display text-[40px] font-300 leading-[1.03] text-ink sm:text-[50px]" data-id="element-309" data-mp="23jj8c1g1eo2k">
            How we decide what goes on here
          </h2>
          <div className="mt-16 grid gap-x-16 gap-y-14 border-t border-line pt-14 sm:grid-cols-2" data-id="element-310" data-mp="2df30ccrhd2m1">
            {about.promises.map(promise => <div key={promise.title} data-id="element-311" data-mp="2m8pszu0e5pr0">
                <h3 className="font-display text-[28px] font-300 leading-tight text-ink" data-id="element-312" data-mp="2m8g4kauzvqnf">
                  {promise.title}
                </h3>
                <p className="mt-4 max-w-md text-[15.5px] leading-[1.85] text-muted" data-id="element-313" data-mp="2w75e9gcqm4sl">
                  {promise.body}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <section aria-labelledby="money-h" className="bg-creme/60" data-id="element-314" data-mp="1ov69zi3lon3b">
        <div className="mx-auto max-w-shell px-6 py-24 lg:px-10 lg:py-28" data-id="element-315" data-mp="1ostiad81iyd2">
          <p className="label text-ink/55" data-id="element-316" data-mp="1swrlp04eevbx">Transparency</p>
          <h2 id="money-h" className="mt-6 max-w-2xl font-display text-[40px] font-300 leading-[1.03] text-ink sm:text-[50px]" data-id="element-317" data-mp="1xut3ziu02qmc">
            {about.money.headline}
          </h2>
          <p className="mt-7 max-w-prose text-[16px] leading-[1.85] text-ink/75" data-id="element-318" data-mp="27k2tqs1dfx7a">
            {about.money.body}
          </p>
          <ol className="mt-16 grid gap-x-16 gap-y-12 border-t border-ink/15 pt-14 lg:grid-cols-3" data-id="element-319" data-mp="2cie2t0jue3og">
            {about.money.streams.map((stream, i) => <li key={stream.name} data-id="element-320" data-mp="2llf66thbpgof" data-mpi={i}>
                <p className="font-display text-[34px] font-300 leading-none text-ink/35" data-id="element-321" data-mp="2lkdmy1q5lnvm">
                  {String(i + 1).padStart(2, '0')}
                </p>
                <h3 className="mt-5 font-display text-[26px] font-300 leading-tight text-ink" data-id="element-322" data-mp="r62vrmm36hmo">
                  {stream.name}
                </h3>
                <p className="mt-3 text-[14.5px] leading-[1.85] text-ink/70" data-id="element-323" data-mp="joobzkzsqz81">
                  {stream.detail}
                </p>
              </li>)}
          </ol>
        </div>
      </section>

      <section aria-labelledby="numbers-h" className="bg-paper" data-id="element-324" data-mp="9vh864kpfra2">
        <div className="mx-auto max-w-shell px-6 py-24 lg:px-10" data-id="element-325" data-mp="4zs1lha9pa49">
          <h2 id="numbers-h" className="label text-muted" data-id="element-326" data-mp="12mr4i9rjzeal">
            Where things stand
          </h2>
          <dl className="mt-14 grid gap-x-16 gap-y-12 border-t border-line pt-14 sm:grid-cols-2 lg:grid-cols-4" data-id="element-327" data-mp="xmmi633yrpcg">
            {about.numbers.map(n => <div key={n.label} data-id="element-328" data-mp="sq4i3gjkwf6g">
                <dt className="sr-only" data-id="element-329" data-mp="omzipmusotm1">{n.label}</dt>
                <dd data-id="element-330" data-mp="om6mhftgpmi5">
                  <span className="block font-display text-[46px] font-300 leading-none text-ink" data-id="element-331" data-mp="oostnecfxzzu">
                    {n.value}
                  </span>
                  <span className="mt-4 block text-[14px] leading-relaxed text-muted" data-id="element-332" data-mp="39bvzdnaluy87">
                    {n.label}
                  </span>
                </dd>
              </div>)}
          </dl>
        </div>
      </section>

      <section aria-labelledby="work-h" className="bg-opal/35" data-id="element-333" data-mp="15wim47wnazld">
        <div className="mx-auto max-w-shell px-6 py-24 text-center lg:px-10" data-id="element-334" data-mp="r74d50wzek6i">
          <p className="label text-ink/60" data-id="element-335" data-mp="w44e4xez4wqr">Say hello</p>
          <h2 id="work-h" className="mx-auto mt-7 max-w-2xl font-display text-[40px] font-300 leading-[1.05] text-ink sm:text-[52px]" data-id="element-336" data-mp="w2jjl7sntdsw">
            Have a place we should know about?
          </h2>
          <p className="mx-auto mt-7 max-w-lg text-[15.5px] leading-[1.85] text-ink/75" data-id="element-337" data-mp="1aubt335rvxmp">
            Tips from local parents are how half of this site got written. And
            if you run a family business here, there’s a straightforward way to
            work together.
          </p>
          <div className="mt-12 flex flex-wrap justify-center gap-4" data-id="element-338" data-mp="3fysm8g3j3pv">
            <Link to="/events" className="label bg-ink px-8 py-4 text-paper transition-colors duration-150 ease-soft hover:bg-olive" data-id="element-339" data-mp="3dvvl4gj0abn">
              Send us a tip
            </Link>
            <Link to="/site-structure" className="label border border-ink/30 px-8 py-4 text-ink transition-colors duration-150 ease-soft hover:bg-ink hover:text-paper" data-id="element-340" data-mp="5ult73osjtxc">
              Advertise with us
            </Link>
          </div>
        </div>
      </section>
    </main>;
}